export default class ChartStoreItem {
	_inputId;
	_inputName;
	_chartData;
	_chartLoaded;
	_isLinkToView;

	constructor(inputProps = {},
		chartData = {},
		chartLoaded = false)
		{
			this._inputId = inputProps.id;
			this._inputName = inputProps.name;
			this._chartData = chartData;
			this._chartLoaded = chartLoaded;
			this._inputProps = inputProps;
		}

		get inputId() {
			return this._inputId;
		}

		set inputId(value) {
			this._inputId = value;
		}

		get inputName() {
			return this._inputName;
		}

		set inputName(value) {
			this._inputName = value;
		}

		get chartData() {
			return this._chartData;
		}

		set chartData(value) {
			this._chartData = value;
		}

		get chartLoaded() {
			return this._chartLoaded;
		}

		set chartLoaded(value) {
			this._chartLoaded = value;
		}

		// get isLinkToView() {
		// 	return this._isLinkToView;
		// }

		// set isLinkToView(value) {
		// 	this._isLinkToView = value;
		// }
	}
